import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SCHEME_STT_STATUS, USER_ROLES } from 'src/app/scheme-constants/scheme-constants';
import {
	DTable,
	Pagination,
	TableActions
} from 'projects/common/src/app/types';
import { TrainingPartnerService } from 'projects/services/src/app/API/training-partner.service';
import * as moment from 'moment';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import * as $ from 'jquery';
import { FileService } from 'projects/services/src/app/API/document/file.service';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { STATUS_CLASS } from '../input/table/table.component';

export const STATUS = {
	CREATED: 'init',
	APPROVED: 'DAAPPROVED',
	REJECTED: 'DABLOCKED',
	SEND_BACK: 'DAREJECTED',
	RESUBMITTED: 'Resubmitted',
	PMKVY_STT: 'approved',
	DRAFT: 'DRAFT',
	ADDITIONAL_DETAILS_REQUIRED: SCHEME_STT_STATUS.ADDITIONAL_DETAILS_REQUIRED
};

export const STATUS_MAPPING = {
	[STATUS.APPROVED]: 'Approved',
	[STATUS.REJECTED]: 'Rejected',
	[STATUS.CREATED]: 'Approval in Progress',
	[STATUS.SEND_BACK]: 'Send Back',
	[STATUS.RESUBMITTED]: 'Resubmitted',
	[STATUS.PMKVY_STT]: 'Approved',
	[STATUS.DRAFT]: 'Draft',
	[STATUS.ADDITIONAL_DETAILS_REQUIRED]: SCHEME_STT_STATUS.ADDITIONAL_DETAILS_REQUIRED
};

const DEFAULT_PAGINATION = Object.freeze({
	PAGE_NO: 1,
	LIMIT: 10,
	COUNT: 0
});

@Component({
  selector: 'app-mpr-list',
  templateUrl: './mpr-list.component.html',
  styleUrls: ['./mpr-list.component.css']
})

export class MprListComponent implements OnInit {

	mprData: any[] = [];
	projectDetails: any;
	userName: String;
	filteredDates = [];
	reportMonthList: any[] = [];
	addReportForm: FormGroup;
	userInfo: any;
  routerInfo: { params: any, queryParams: any } = { params: {}, queryParams: {} };

  paginationData: Pagination = {
		count: 10,
		limit: DEFAULT_PAGINATION.LIMIT,
		pageNo: 1,
		pageNum: 1
  }

	addedReportingMonth = [];
	createMode = true;
	mprTable = new DTable({
		headers: {
			fullName: 'Full Name',
			desi: 'Designation',
			lastUpdated: 'Last Updated On',
			projTyp: 'Project Type',
			reportMnth: 'Reporting Month:',
			// status: 'Status',
			action: 'Action'
		},
		fieldMapping: {
			status: STATUS_MAPPING
		},
		dynamicClasses: {
			status: {
				[STATUS.CREATED]: STATUS_CLASS.INFO,
				[STATUS.APPROVED]: STATUS_CLASS.SUCCESS,
				[STATUS.PMKVY_STT]: STATUS_CLASS.SUCCESS,
				[STATUS.REJECTED]: STATUS_CLASS.DANGER,
				[STATUS.SEND_BACK]: STATUS_CLASS.WARNING,
				[STATUS.RESUBMITTED]: STATUS_CLASS.INFO,
				[STATUS.DRAFT]: STATUS_CLASS.PRIMARY,
				[STATUS.ADDITIONAL_DETAILS_REQUIRED]: STATUS_CLASS.LATE
			}
		},
		// onPaginationChange: this.selectedPage.bind(this
		pagination: new Pagination(),
		data: this.mprData
  });
	monthNumber: string;

	constructor(
	private fb: FormBuilder,
	private fileService: FileService,
	private tpService: TrainingPartnerService,
	private activatedRoute: ActivatedRoute,
	private location: Location,
	private currentUserService: CurrentUserService,
		private router: Router) {
		// Setting form group and it form control for report month popup
		this.addReportForm = this.fb.group({
			'reportingMonth': ['', Validators.required]
		})
	}

	ngOnInit() {
		// if (this.activatedRoute.parent.snapshot.data &&
		// 	this.activatedRoute.parent.snapshot.data.user &&
		// 	this.activatedRoute.parent.snapshot.data.user.role === 'RPL PMU') {
		// 	this.createMode = false
		// } else {
		// 	this.createMode = true
		// }
		this.getCurrentUserDetails();
		this.activatedRoute.params.subscribe(params => {
		this.routerInfo.params = params;
		console.log(params);
		this.userName = params.tpId ? params.tpId : '';
		const schemeID = params.id;
		const projectID = params.schemeId;
		this.tpService.getAllMPRs(schemeID, projectID).subscribe(res => {
			console.log(res);
			this.mprData = res.monthlyReports;
			let mappedProjects = [];
			if (this.mprData) {
				 mappedProjects = this.mprData.map(scheme => {
					return Object.assign(scheme, {
						fullName: scheme.fullName || '--',
						desi: scheme.desi,
						lastUpdated: this.formatDateTime(scheme.updatedAt ? scheme.updatedAt : '--'),
						projTyp: scheme.projTyp,
						reportMnth: this.formatDateToMonth(scheme.reportMnth),
						action: this.createAction(scheme),
						// selectedSchemeId: scheme._id,
					});
				 });
				 this.mprData.forEach(arr => {
					this.addedReportingMonth.push(arr.reportMnth);
				});
			}
			this.mprTable.data = mappedProjects;
			this.getProjectDates(this.userName, projectID);
		});
  });
  }

  getCurrentUserDetails() {
	return this.currentUserService.getCurrentUser().subscribe(res => {
		this.userInfo = res;
	})
}
get isRoleRPL(): boolean{
	if (this.userInfo.role === USER_ROLES.RPL_PMU ||
		this.userInfo.role === USER_ROLES.SSDM_PMU_RPL ||
		this.userInfo.role === USER_ROLES.STATE_SCHEME_PMU
	) {
		 return false;
	 }
	 else {
		return true;
	}
}

	private getProjectDates(userName, projectID) {
		this.tpService.getTPProjectById(userName, projectID).subscribe(result => {
			console.log(result);
			const data = result;
			this.projectDetails = result.schemes;
			if (data.schemes && data.schemes.duration) {
				const fromDate = moment(data.schemes.duration.fromDate);
				const previousDate = moment().subtract(1, 'month').add(1, 'day');
				while (previousDate > fromDate || fromDate.format('M') === previousDate.format('M')) {
					this.monthNumber = fromDate.format('M');
					console.log('Numberrrrr', this.monthNumber);
					this.reportMonthList.push(fromDate.format('MMM-YYYY'));
					fromDate.add(1, 'month');
				}
				if (this.addedReportingMonth && this.addedReportingMonth.length) {
					// const filteredDates = this.reportMonthList.filter(e => {
					// 	return this.addedReportingMonth.indexOf(e) > -1;
					// });
					this.reportMonthList.map(month => {
						const mIndex = this.addedReportingMonth.findIndex(mon => mon === month.replace(/-/g, ' '))
						if (mIndex === -1) {
							this.filteredDates.push(month);
						}
					})
					 this.reportMonthList = this.filteredDates;
				}
			}
		});
	}

	private createAction(scheme: any) {
		let action: TableActions;
		action = new TableActions([
			{
				label: 'View Details',
				onSelect: this.onSelectViewMpr.bind(this)
			},
		]);
		// if (this.createMode) {
		if (this.isRoleRPL){
			action.push({
				label: 'Edit',
				onSelect: this.onSelectEditMpr.bind(this)
			});
		}
		return action;
	}

	private onSelectViewMpr(data) {
		const pid = this.routerInfo.params.schemeId;
		const reprt_date = moment(`01-${data.reportMnth}`, 'DD-MMM-YYYY').format();
		const rep_date = new Date(reprt_date).toISOString();
		console.log(data.reportMnth);
		this.tpService.downloadMprPdf(this.userName, pid, rep_date, this.projectDetails.type).subscribe(res => {
			console.log(res);
			this.fileService.downloadAttachedFile(res.mpreportpath);
		});
	//   console.log('view data', data);
	//   this.router.navigate(['../../../view-mpr', this.routerInfo.params.id, this.routerInfo.params.schemeId, data.reportMnth],
	//   { relativeTo: this.activatedRoute});
  }

private onSelectEditMpr(data) {
	console.log('edit data', data);
	const monthValue = new Date(data.reportMnth).getMonth() + 1;
	this.router.navigate(['../../../../edit-mpr', this.routerInfo.params.id, this.routerInfo.params.schemeId , data.reportMnth],
		{
			relativeTo: this.activatedRoute,
			queryParams: {
				monthNumber: monthValue
			}
		});
  }

  onBack() {
		this.location.back();
  }

	addMPR() {
	$('#add-mr').fadeOut();
		$('.modal-backdrop').fadeOut();
		const monthValue = new Date(this.addReportForm.get('reportingMonth').value).getMonth() + 1;
	// tslint:disable-next-line:max-line-length
	this.router.navigate(['../../../../create-mpr', this.routerInfo.params.id, this.routerInfo.params.schemeId, this.addReportForm.get('reportingMonth').value],
		{
			relativeTo: this.activatedRoute,
		// acoording to tester batch should come according to month,
		// queryParams: {rplType: this.activatedRoute.snapshot.queryParams.rplType, monthNumber: this.monthNumber}});
		queryParams: {rplType: this.activatedRoute.snapshot.queryParams.rplType, monthNumber: monthValue}});
  }

  formatDateToMonth(data) {
	  const date = moment(data).format('MMM YYYY');
	  return date;
  }

	formatDateTime(data) {
	const date = (data !== '') ? moment(data).format('DD MMM YYYY hh:mm A') : '';
	return date;
  }

  addMPRPopup() {
	Helpers.openModal('add-mpr');
  }

}
